export default {
    methods: {
        hasPermissionAdd() {
            return this.$store.getters.hasPermission(this.$route.path, {action: "Add"});
        },
        hasPermissionEdit() {
            return this.$store.getters.hasPermission(this.$route.path, {action: "Edit"});
        },
        hasPermissionDelete() {
            return this.$store.getters.hasPermission(this.$route.path, {action: "Delete"});
        },
    },
}